import React, { useState } from 'react';

// A "Delete selected" button that asks once, in place, before it deletes. onDelete is called when it is confirmed.
export default function DeleteSelected({ count, busy, noun, onDelete }) {
  const [confirming, setConfirming] = useState(false);
  const label = `${count} ${noun}${count === 1 ? '' : 's'}`;
  if (!confirming || count === 0) {
    return <button type="button" className="btn btn-sm" disabled={count === 0 || busy} onClick={() => setConfirming(true)}>Delete selected ({count})</button>;
  }
  return (
    <>
      <button type="button" className="btn btn-sm danger" disabled={busy} onClick={async () => { setConfirming(false); await onDelete(); }}>{`Confirm: delete ${label}`}</button>
      <button type="button" className="btn btn-ghost btn-sm" onClick={() => setConfirming(false)}>Keep</button>
    </>
  );
}
